import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import screenfull from 'screenfull';
import { mapActions } from 'vuex';
import moment from 'moment';
import atmosphere from "./tab/atmosphere";
import dynamicSupervision from "./tab/dynamicSupervision";
import waterRegime from "./tab/waterRegime";
import workingCondition from "./tab/workingCondition";
export default {
  name: 'index',
  components: {
    atmosphere: atmosphere,
    dynamicSupervision: dynamicSupervision,
    waterRegime: waterRegime,
    workingCondition: workingCondition
  },
  data: function data() {
    return {
      titleLogo: '',
      waterName: '',
      headDate: '',
      headTime: '',
      selectId: 1,
      tabList: [{
        id: 1,
        name: '汕尾气象'
      }, {
        id: 2,
        name: '汕尾水情'
      }, {
        id: 3,
        name: '汕尾工情'
      }, {
        id: 4,
        name: '动态监管'
      }],
      isFullscreen: false
    };
  },
  created: function created() {
    var _this = this;

    this.titleLogo = window.localStorage.getItem('titleLogo');
    this.waterName = window.localStorage.getItem('waterName');
    setInterval(function () {
      var date = new Date();
      _this.headDate = moment(date).format('YYYY年MM月DD日');
    }, 60000);
    this.getDate();
  },
  methods: _objectSpread(_objectSpread(_defineProperty({
    getDate: function getDate() {
      var _this2 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this2.headTime = moment(time).format('HH:mm:ss');

        _this2.$forceUpdate();
      }, 1000);
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    },
    // 点击头部导航栏
    onToTab: function onToTab(id, index) {
      this.selectId = id; // let data
      // switch (id) {
      //   case 1:
      //     data = JSON.parse(JSON.stringify(this.atmosphereList))
      //     this.atmosphereList = []
      //     this.$nextTick(() => {
      //       this.atmosphereList = data
      //     })
      //     break
      //   case 2:
      //     data = JSON.parse(JSON.stringify(this.waterQualityList))
      //     this.waterQualityList = []
      //     this.$nextTick(() => {
      //       this.waterQualityList = data
      //     })
      //     break
      //   case 3:
      //     data = JSON.parse(JSON.stringify(this.hydrologyList))
      //     this.hydrologyList = []
      //     this.$nextTick(() => {
      //       this.hydrologyList = data
      //     })
      //     break
      //   case 4:
      //     data = JSON.parse(JSON.stringify(this.workingList))
      //     this.workingList = []
      //     this.$nextTick(() => {
      //       this.workingList = data
      //     })
      //     break
      // }
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    }
  }, "goHome", function goHome() {
    this.$router.push('/monitor/map');
  }), mapActions(['Logout'])), {}, {
    logout: function logout() {
      var that = this;
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: function onOk() {
          return that.Logout({}).then(function () {
            window.location.href = '/'; //window.location.reload()
          }).catch(function (err) {
            that.$message.error({
              title: '错误',
              description: err.message
            });
          });
        },
        onCancel: function onCancel() {}
      });
    }
  })
};